/**
 * Rank Ladder Admin API Endpoints
 * Points thresholds for the ten named rank tiers (Admin API).
 *
 * `/admin/*` paths are rewritten to the Admin API's `/api/*` — see api/client.ts.
 */

import { ApiService } from '../apiService'
import type { RankThresholdsResponse, UpdateRankThresholdsRequest } from '../types/rankThresholds'

export const rankThresholdsApi = {
  /** All ten tiers with effective thresholds, defaults and override provenance. */
  get: () => ApiService.get<RankThresholdsResponse>('/admin/rank-thresholds'),

  /**
   * Replaces all nine tunable thresholds. Rejected with 400 unless the ladder is strictly
   * ascending — an out-of-order rung would be silently unreachable.
   */
  update: (request: UpdateRankThresholdsRequest) =>
    ApiService.put<RankThresholdsResponse>('/admin/rank-thresholds', request),

  /** Removes every stored override, returning the ladder to the compiled defaults. */
  reset: () => ApiService.post<RankThresholdsResponse>('/admin/rank-thresholds/reset'),
}
